import { WarehouseDashboardService } from '@gtpl/shared-services/analytics'
import { Button, Card,Col,Empty,Form, Input, Row, Select, Table } from 'antd'
import React, { useEffect, useRef, useState } from 'react'
import { ColumnProps } from 'antd/lib/table'
import { PackageTypeEnum, StockStatus, StockTypeDropDown } from '@gtpl/shared-models/common-models'
import { SPSAStockValuationReq } from '@gtpl/shared-models/warehouse-management'
import {FileExcelOutlined,SearchOutlined} from '@ant-design/icons';
import { Excel } from 'antd-table-saveas-excel';
import Highlighter from 'react-highlight-words';

const {Option} = Select
export const SPSAStockValuationReport = () => {
    let stockType = StockTypeDropDown.filter(e => {return(e.name != 'Super Dummy' && e.name != 'Anticipated')});
    const service = new WarehouseDashboardService()
    const [stockInfo,setStockInfo] = useState<any[]>([])
    const [page,setPage] = useState<number>(1)
    const [form] = Form.useForm()
    const [productSkus,setProductSkus] = useState<any[]>([])
    const [customerPOs,setCustomerPOs] = useState<any[]>([])
    const [lotNumbersInfo,setlotNumbersInfo] = useState<any[]>([])
    const searchInput = useRef(null);
    const [searchText, setSearchText] = useState('');
    const [searchedColumn, setSearchedColumn] = useState('');


    useEffect(() => {
        getStockValuationInfo()
        getProductSKUInfo()
        getCustomerPOInfo()
        getLotNumberInfo()
    },[])

    const getStockValuationInfo = () => {
        const req = new SPSAStockValuationReq(form.getFieldValue('skuCodeId'),form.getFieldValue('saleOrderId'),form.getFieldValue('stockType'),form.getFieldValue('lotNumber'))
        service.getSPSAStockValuationReport(req).then(res => {
            if(res.status){
                setStockInfo(res.data)
            }else{
                setStockInfo([])
            }
        })
    }

    const getProductSKUInfo = () => {
        service.getProductSkuDropdown().then(res => {
            if(res.status){
                setProductSkus(res.data)
            }else{
                setProductSkus([])
            }
        })
    }

    const getCustomerPOInfo = () => {
        service.getCustomerPoDropdown().then(res => {
            if(res.status){
                setCustomerPOs(res.data)
            }else{
                setCustomerPOs([])
            }
        })
    }

    const getLotNumberInfo = () => {
        service.getLotNumberDropdown().then(res => {
            if(res.status){
                setlotNumbersInfo(res.data)
            }else{
                setlotNumbersInfo([])
            }
        })
    }

    function handleSearch(selectedKeys, confirm, dataIndex) {
        confirm();
        setSearchText(selectedKeys[0]);
        setSearchedColumn(dataIndex);
    }

    function handleReset(clearFilters) {
        clearFilters();
        setSearchText('');

    }

    const getColumnSearchProps = (dataIndex: string) => ({
        filterDropdown: ({
            setSelectedKeys,
            selectedKeys,
            confirm,
            clearFilters,
        }) => (
            <div style={{ padding: 8 }}>
                <Input
                    ref={searchInput}
                    placeholder={`Search ${dataIndex}`}
                    value={selectedKeys[0]}
                    onChange={(e) =>
                        setSelectedKeys(e.target.value ? [e.target.value] : [])
                    }
                    onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
                    style={{ width: 188, marginBottom: 8, display: 'block' }}
                />
                <Button
                    type="primary"
                    onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
                    icon={<SearchOutlined />}
                    size="small"
                    style={{ width: 90, marginRight: 8 }}
                >
                    Search
                </Button>
                <Button
                    onClick={() => handleReset(clearFilters)}
                    size="small"
                    style={{ width: 90 }}
                >
                    Reset
                </Button>
            </div>
        ),
        filterIcon: (filtered) => (
            <SearchOutlined
                type="search"
                style={{ color: filtered ? '#1890ff' : undefined }}
            />
        ),
        onFilter: (value, record) =>
            record[dataIndex]
                ? record[dataIndex]
                    .toString()
                    .toLowerCase()
                    .includes(value.toLowerCase())
                : false,
        onFilterDropdownVisibleChange: (visible) => {
            if (visible) {
                setTimeout(() => searchInput.current.select());
            }
        },
        render: (text) =>
            text ? (
                searchedColumn === dataIndex ? (
                    <Highlighter
                        highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
                        searchWords={[searchText]}
                        autoEscape
                        textToHighlight={text.toString()}
                    />
                ) : (
                    text
                )
            ) : null,
    });

    const columns : ColumnProps<any>[] = [
        {
            title: 'S No',
            key: 'sno',
            width: '70px',
            responsive: ['sm'],
            render: (text, object, index) => (page - 1) * 10 + (index + 1)
        },
        {
            title:'Stock Type',
            dataIndex:'stockType',
            filters: Object.values(StockStatus).filter(val => [StockStatus.SaleOrder, StockStatus.dummy].includes(val)).map(val => ({
                text: val,
                value: val
            })),
            filterMultiple: true,
            onFilter: (value, record) => {
                return record.stockType == value;
            },
        },
        {
            title:'Customer PO',
            dataIndex :'customerPo',
            sorter: (a, b) => a.customerPo.localeCompare(b.customerPo),
            sortDirections: ['descend', 'ascend'],
            ...getColumnSearchProps('stockInType')

        },
        {
            title:'Lot Number',
            dataIndex:'lotNumber',
            sorter: (a, b) => a.lotNumber.localeCompare(b.lotNumber),
            sortDirections: ['descend', 'ascend'],
            ...getColumnSearchProps('lotNumber')
        },
        {
            title:'Product SKU',
            dataIndex:'productSKU',
            sorter: (a, b) => a.lotNumber.localeCompare(b.lotNumber),
            sortDirections: ['descend', 'ascend'],
            ...getColumnSearchProps('lotNumber')
        },
        {
            title:'Pack Style',
            dataIndex:'packStyle',
            sorter: (a, b) => a.lotNumber.localeCompare(b.lotNumber),
            sortDirections: ['descend', 'ascend'],
            ...getColumnSearchProps('lotNumber')
        },
        {
            title:'Package Type',
            dataIndex:'packageType',
            filters: Object.values(PackageTypeEnum).map(val => ({
                text: val,
                value: val
            })),
            filterMultiple: true,
            onFilter: (value, record) => {
                return record.packageType == value;
            },
        },
        {
            title:'Packages',
            dataIndex:'packages',
            sorter: (a, b) => a.packages - b.packages,
            sortDirections: ['descend', 'ascend'],
        },
        {
            title:'Tare Weight',
            dataIndex:'tareWeight',
            sorter: (a, b) => a.tareWeight - b.tareWeight,
            sortDirections: ['descend', 'ascend'],
            render:(text,record) => {
                return(
                    record.tareWeight ? Number(record.tareWeight) : '-'
                )
            }
        },
        {
            title:'Quantity',
            dataIndex:'quantity',
            sorter: (a, b) => a.quantity - b.quantity,
            sortDirections: ['descend', 'ascend'],
            render:(text,record) => {
                return(
                    record.quantity ? Number(record.quantity) : '-'
                )
            }
        },
        {
            title:'Price',
            dataIndex:'price',
            sorter: (a, b) => a.price - b.price,
            sortDirections: ['descend', 'ascend'],
            render:(text,record) => {
                return(
                    record.price ? Number(record.price) : '-'
                )
            }
        },

        {
            title:'Amount',
            dataIndex:'amount',
            sorter: (a, b) => a.amount - b.amount,
            sortDirections: ['descend', 'ascend'],
            render:(text,record) => {
                return(
                    record.amount ? Number(record.amount) : '-'
                )
            }
        }
    ]

    const onReset = () => {
        form.resetFields()
        setStockInfo([])
    }

    const onGetReport = () => {
        getStockValuationInfo()
    }

    const data = [
        { title: "Sno", dataIndex: "sno", render: (text, object, index) => (page - 1) * 10 + (index + 1) },
        { title: 'Stock Type', dataIndex: 'stockType' },
        { title: "Customer PO", dataIndex: "customerPo" },
        { title: 'Lot Number', dataIndex: 'lotNumber' },
        { title: "Product SKU", dataIndex: "productSKU" },
        { title: "Pack Style", dataIndex: "packStyle" },
        { title: "Package Type", dataIndex: "packageType" },
        { title: "Packages", dataIndex: "packages", string2Num: true },
        { title: "Tare Weight", dataIndex: "tareWeight", render: (value) => value ? Number(Number(value).toFixed(2)) : '-' },
        { title: "Quantity", dataIndex: "quantity", render: (value) => value ? Number(Number(value).toFixed(2)) : '-' },
        { title: "Price", dataIndex: "price", render: (value) => value ? Number(Number(value).toFixed(2)) : '-' },
        { title: "Amount", dataIndex: "amount", render: (value) => value ? Number(Number(value).toFixed(2)) : '-' }
    ];

    const exportExcel = () => {
        const excel = new Excel();
        excel
            .addSheet('Stock Valuation')
            .addColumns(data)
            .addDataSource(stockInfo, { str2num: true })
            .saveAs('stock-valuation.xlsx');
    }
    return(
        <Card size='small' title={<span style={{color:'white'}}>Stock Valuation Report</span>} style={{textAlign:'center'}} headStyle={{backgroundColor: '#69c0ff', border: 0 }}
           extra={stockInfo.length > 0 && (
            <Button icon={<FileExcelOutlined />}  onClick={() => { exportExcel(); }}>
                    Get Excel
                </Button>
                                
        )}>
            <Form form={form} onFinish={onGetReport}>
                <Row gutter={24}>
                    <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 4 }} lg={{ span: 4 }} xl={{ span: 4 }}>
                        <Form.Item name='skuCodeId' label='Product SKU'>
                            <Select allowClear showSearch optionFilterProp="children" placeholder='Select Product SKU'>
                                {
                                    productSkus.map((e) => {
                                        return(
                                            <Option value={e.skuCodeId} key={e.skuCodeId}>{e.productSKU}</Option>
                                        )
                                    })
                                }
                            </Select>
                        </Form.Item>
                    </Col>
                    <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 4 }} lg={{ span: 4 }} xl={{ span: 4 }}>
                        <Form.Item name='saleOrderId' label='Customer PO'>
                            <Select allowClear showSearch optionFilterProp="children" placeholder='Select Customer PO'>
                                {
                                    customerPOs.map((e) => {
                                        return(
                                            <Option value={e.saleOrderId} key={e.saleOrderId}>{e.customerPo}</Option>
                                        )
                                    })
                                }
                            </Select>
                        </Form.Item>
                    </Col>
                    <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 4 }} lg={{ span: 4 }} xl={{ span: 4 }}>
                        <Form.Item name='stockType' label='Stock Type'>
                            <Select showSearch allowClear optionFilterProp="children" placeholder='Select Stock Type'>
                                {stockType.map(stockType => {
                                    return <Option value={stockType.value}>{stockType.name}</Option>
                                })}
                            </Select>
                        </Form.Item>
                    </Col>
                    <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 4 }} lg={{ span: 4 }} xl={{ span: 4 }}>
                        <Form.Item name='lotNumber' label='Lot Number'>
                            <Select allowClear showSearch optionFilterProp="children" placeholder='Select Lot Number'>
                                {
                                    lotNumbersInfo.map((e) => {
                                        return(
                                            <Option value={e.lotNumber} key={e.lotNumber}>{e.lotNumber}</Option>
                                        )
                                    })
                                }
                            </Select>
                        </Form.Item>
                    </Col>
                     <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 4 }} lg={{ span: 4 }} xl={{ span: 2 }}>
                    <Form.Item >
                       <Button type='primary' htmlType='submit'>Get Report</Button>
                    </Form.Item>
                    </Col>
                    <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 4 }} lg={{ span: 4 }} xl={{ span: 2 }}>
                    <Form.Item>
                       <Button type='primary' onClick={onReset}>Reset</Button>
                    </Form.Item>
                    </Col>
                </Row>
            </Form>
            {
                stockInfo.length > 0 ? (
                    <Table columns={columns} dataSource={stockInfo} size='small'
                    summary={(pageData) => {
                        let totQty = 0
                        let totAmount = 0
                        pageData.forEach(({quantity,amount}) => {
                            totQty += Number(quantity)
                            totAmount += Number(amount)
                        })
                        return(
                            <>
                                <Table.Summary.Row className="tableFooter">
                                    <Table.Summary.Cell index={0} colSpan={9} align='right'>Total</Table.Summary.Cell>
                                    <Table.Summary.Cell index={10} colSpan={2} align='left'>{Number(totQty.toFixed(2))}</Table.Summary.Cell>
                                    <Table.Summary.Cell index={12} align='left'>{totAmount}</Table.Summary.Cell>
                                </Table.Summary.Row>
                            </>
                        )
                    }}
                    />
                ) : (
                    <Empty description="No Data Found" />
                )
            }
        </Card>
    )

}

export default SPSAStockValuationReport
